/* 
    个人资料
 */
 <template>
  <div class="my-personl">
    <Form
      ref="formMyPersonal"
      :model="formMyPersonal"
      :rules="ruleMyPersonal"
      label-position="left"
      :label-width="100"
    >
      <FormItem label="用户头像" style="width:80px;">
        <z-upload
          v-if="Object.keys(ossKeys).length > 0"
          :type="5"
          @success="successHandle"
          :maxSize="5120"
          :ossKey="ossKeys"
          :progressBar="true"
        >
          <Avatar
            :icon="formMyPersonal.avatarFile ? '' : 'ios-person'"
            :src="formMyPersonal.avatarFile ? imgBaseUrl + formMyPersonal.avatarFile.key: ''"
            class="personal-avater"
            size="large"
          />
        </z-upload>
      </FormItem>
      <FormItem label="用户昵称" style="width:600px;" prop="loginName">
        <Input v-model="formMyPersonal.loginName" :maxlength="20" placeholder="请输入用户名"></Input>
      </FormItem>
      <FormItem label="用户ID" style="text-align:left;">
        <span class="personal-identity">{{formMyPersonal.uuid}}</span>
        <Button
          size="small"
          class="copy"
          :data-clipboard-text="formMyPersonal.uuid"
          @click="copyUuid"
        >复制</Button>
      </FormItem>
      <FormItem label="性别" prop="sex" style="width:250px;" class="my-personal-sex">
        <RadioGroup v-model="formMyPersonal.sex">
          <Radio label="女">男</Radio>
          <Radio label="男">女</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="手机号码" style="text-align:left;">
        <span class="personal-identity">
          {{formMyPersonal.phone}}&nbsp;&nbsp;
          <span style="color:#F5A623">已绑定</span>
        </span>
      </FormItem>
      <FormItem label="用户属性" style="text-align:left;">
        <span class="personal-identity">{{formMyPersonal.typeDisplay}}</span>
      </FormItem>
      <FormItem class="personal-margin-left">
        <Row type="flex" align="middle">
          <Col span="7">
            <Button type="primary" long :loading="loading" @click="saveUserInfo">保存</Button>
          </Col>
        </Row>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import _ from "lodash";
import api from "../../../../../api/index";
import Clipboard from "clipboard";
export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("此内容为必填项"));
      }
      callback();
    };
    const validatePhone = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("此内容为必填项"));
      } else {
        if (!/^1[0-9]{10}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
      }
      callback();
    };
    return {
      imgBaseUrl: api.common.imgBaseUrl,
      ossKeys: {},
      loading: false,
      formMyPersonal: {
        loginName: "",
        sex: "男",
        phone: "",
        avatarFile: ""
      },
      ruleMyPersonal: {
        loginName: [{ validator: validateName, trigger: "blur,change" }],
        phone: [{ validator: validatePhone, trigger: "blur,change" }]
      }
    };
  },
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  watch: {
    info: function() {
      _.assign(this.formMyPersonal, this.info);
    }
  },
  methods: {
    successHandle(file) {
      this.formMyPersonal.avatarFile = file.data[0];
    },
    getOssKey(type) {
      api.files.uploadUrl(type).then(res => {
        this.ossKeys = res;
      });
    },
    /* 保存用户信息 */
    saveUserInfo() {
      this.$refs["formMyPersonal"].validate(valid => {
        if (valid) {
          this.loading = true;
          api.account
            .updateInformation(this.formMyPersonal)
            .then(() => {
              this.$store.commit("SET_USER", this.formMyPersonal);
              this.$Message.success("保存成功");
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
            });
        } else {
          this.$Message.error("请把信息填写完整!");
        }
      });
    },
    /* 复制用户ID */
    copyUuid() {
      let clipboard = new Clipboard(".copy");
      setTimeout(() => {
        this.$Message.success("成功复制到剪切板");
      },500)
    }
  },
  created() {
    this.getOssKey(5);
  }
};
</script>

<style lang="scss">
.my-personl {
  .personal-avater {
    width: 72px;
    height: 72px;
    line-height: 72px;
    border-radius: 50%;
    vertical-align: middle;
    font-size: 35px;
    margin-top: -15px;
  }
  .ivu-form-item-label {
    font-size: 14px;
  }
  .my-personal-sex {
    .ivu-radio-group {
      margin-top: 5px;
    }
    .ivu-radio-group-item {
      font-size: 14px;
      &:last-child {
        margin-left: 60px;
      }
    }
  }
  .personal-identity {
    font-size: 14px;
    color: #9b9b9b;
    display: inline-block;
    margin-top: 5px;
  }
  .personal-margin-left {
    margin-top: 50px;
    width: 700px;
  }
  .copy {
    height: 25px;
    margin-left: 20px;
  }
  .ivu-avatar {
    img {
      object-fit: cover;
    }
  }
}
</style>


 